import { useEffect, useState } from "react";
import axios from "../libs/axios";

export default function ReachTotals() {
  const [campaigns, setCampaigns] = useState([]);

  useEffect(() => {
    const getCampaigns = async () => {
      try {
        const res = await axios.get("/campaign-results");

        if (res.status !== 200) throw new Error("Can not get campaigns.");

        setCampaigns(res.data);
      } catch (err) {
        console.log(err);
      }
    };

    getCampaigns();
  }, []);

  return campaigns && campaigns.length > 0 ? (
    <>
      <div className="pt-6"></div>
      <div className="social-reach-bg mt-12 py-10 px-4 md:px-0">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-10">
          კამპანიის შედეგები
        </h2>
        <div className="grid box-border w-full max-w-6xl mx-auto px-4 md:px-20 grid-cols-1 md:grid-cols-2 gap-4">
          {campaigns.map((campaign) => (
            <div
              key={campaign._id}
              className="card bg-base-100 shadow-xl w-full"
            >
              <div className="card-body">
                <h3 className="text-center card-title font-bold justify-center mt-3">
                  {campaign?.year} წლის კამპანიის შედეგი
                </h3>
                <p className="font-extrabold text-center text-lg md:text-2xl mt-3">
                  ✅ {campaign?.reach} წვდომა
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  ) : (
    ""
  );
}
